// extracted by mini-css-extract-plugin
export default {"canvasContainer":"PlaygroundPage_canvasContainer__OH0Jb","phaser-game":"PlaygroundPage_phaser-game__sdny9"};